import axios from 'axios';
import URLS from '../config/urls';
import { attachAxiosCertWarning } from 'utils/certWarning';

const requestInstance = axios.create({
	validateStatus: (status) => {
		if (status === 401) {
			window.location.href = URLS.core.logout.url;
		}

		return true;
	},
});

attachAxiosCertWarning(requestInstance);

export default requestInstance;
